module.exports = __webpack_public_path__ + "static/video-splash-51c6c6ac2390edc7adfe3723748da602.png";